module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/cloud-wind-2dd6de01227ce88f4b74ef85f897caf8.svg";